/* tslint:disable */
/* eslint-disable */
/**
 * Syte Products API
 * API services for CRA, Files, and Collaborators
 *
 * The version of the OpenAPI document: v0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { ApiResponseCdmaChartTimeSeriesResponseFromJSON, ApiResponseScoreReadResponseFromJSON, } from '../models';
/**
 *
 */
export class ScoreControllerApi extends runtime.BaseAPI {
    /**
     */
    chartTimeSeriesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling chartTimeSeries.');
            }
            if (requestParameters.cdmaId === null || requestParameters.cdmaId === undefined) {
                throw new runtime.RequiredError('cdmaId', 'Required parameter requestParameters.cdmaId was null or undefined when calling chartTimeSeries.');
            }
            const queryParameters = {};
            if (requestParameters.startDate !== undefined) {
                queryParameters['startDate'] = requestParameters.startDate;
            }
            if (requestParameters.endDate !== undefined) {
                queryParameters['endDate'] = requestParameters.endDate;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/v1/org/{organizationId}/cra/cdmas/{cdmaId}/scores/chart-time-series`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"cdmaId"}}`, encodeURIComponent(String(requestParameters.cdmaId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponseCdmaChartTimeSeriesResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    chartTimeSeries(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.chartTimeSeriesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    overallScoreRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling overallScore.');
            }
            if (requestParameters.cdmaId === null || requestParameters.cdmaId === undefined) {
                throw new runtime.RequiredError('cdmaId', 'Required parameter requestParameters.cdmaId was null or undefined when calling overallScore.');
            }
            const queryParameters = {};
            if (requestParameters.endDate !== undefined) {
                queryParameters['endDate'] = requestParameters.endDate;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/v1/org/{organizationId}/cra/cdmas/{cdmaId}/scores/overall`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"cdmaId"}}`, encodeURIComponent(String(requestParameters.cdmaId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponseScoreReadResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    overallScore(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.overallScoreRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
